import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaFileInvoiceDollar, FaCalendarAlt, FaIdCard, FaSpinner } from 'react-icons/fa';
import { Oval } from "react-loader-spinner"; // Assuming Oval loader is available
import { StandardURL } from "../App";

const MonthlyStatementForm = () => {
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [propertyId, setPropertyId] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!month || !year || !propertyId) {
      toast.error("Please fill in all fields.");
      return;
    }

    const token = localStorage.getItem("token");
    const requestData = {
      month: parseInt(month, 10),
      year: parseInt(year, 10),
      property_id: propertyId,
    };

    try {
      setLoading(true);
      const response = await axios.post(
        `${StandardURL}/iNyumba/monthlystatementreportmanual`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      // Enhanced success message
      toast.success(`Statement for ${new Date(0, month - 1).toLocaleString("default", { month: "long" })} ${year} generated successfully!`);
      console.log(response.data);
    } catch (error) {
      // Enhanced error handling to display API message if available
      const errorMessage = error.response?.data?.response || "Failed to generate the statement. Please verify the inputs and try again.";
      toast.error(errorMessage);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Helper component for styled input fields
  const FormInput = ({ label, value, onChange, placeholder, icon: Icon, type = "text", children }) => (
    <div className="mb-6">
      <label className="block text-sm font-medium text-gray-700 flex items-center mb-2">
        <Icon className="mr-2 text-indigo-500 w-4 h-4" />
        {label}
      </label>
      {children ? (
        children // Render select/dropdown
      ) : (
        <input
          type={type}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 shadow-sm transition duration-150"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      )}
    </div>
  );

  // Get a list of years, e.g., current year +/- 5
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);


  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
     
      <div className="w-full max-w-lg bg-white shadow-2xl rounded-xl p-8 border-t-4 border-indigo-600">
        
        <div className="flex items-center mb-6">
          <FaFileInvoiceDollar className="w-8 h-8 text-indigo-600 mr-3" />
          <h2 className="text-2xl font-extrabold text-gray-900">Generate Monthly Statement Report</h2>
        </div>

        <p className="text-gray-600 mb-6 border-b pb-4">
            Select the month, year, and specify the property ID to generate the corresponding financial statement.
        </p>

        <form onSubmit={handleSubmit}>
          
          <div className="grid grid-cols-2 gap-4">
            {/* Month Select */}
            <FormInput label="Month" icon={FaCalendarAlt}>
              <select
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 shadow-sm transition duration-150 appearance-none bg-white"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                required
              >
                <option value="">Select Month</option>
                {Array.from({ length: 12 }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {new Date(0, i).toLocaleString("default", { month: "long" })}
                  </option>
                ))}
              </select>
            </FormInput>

            {/* Year Select */}
            <FormInput label="Year" icon={FaCalendarAlt}>
              <select
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 shadow-sm transition duration-150 appearance-none bg-white"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                required
              >
                <option value="">Select Year</option>
                {yearOptions.map(y => (
                    <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </FormInput>
          </div>

          {/* Property ID Input */}
          <FormInput
            label="Property ID"
            placeholder="Enter Property ID (e.g., 12345)"
            value={propertyId}
            onChange={(e) => setPropertyId(e.target.value)}
            icon={FaIdCard}
            type="text"
            required
          />

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full inline-flex items-center justify-center bg-indigo-600 text-white font-semibold py-3 rounded-lg hover:bg-indigo-700 transition duration-300 ease-in-out shadow-md disabled:opacity-50 disabled:cursor-not-allowed mt-4"
            disabled={loading}
          >
            {loading ? (
              <div className="flex items-center">
                <FaSpinner className="animate-spin mr-3 w-5 h-5" />
                Processing Request...
              </div>
            ) : (
              "Generate Statement"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default MonthlyStatementForm;